import { merge } from "lodash";

import { SET } from "src/shared/utilities/state/shared/constants/reducerState";

import {
  MERGE,
  RESET_CONTACT_FORM_TYPE,
  RESET_MESSAGE_SCREENING_FLAG,
  RESET_MODAL_AGENT,
  RESET_POST_SUBMIT_ANSWERS,
  RESET_QUESTIONNAIRE_STEP,
  SET_CONTACT_FORM_TYPE,
  SET_MESSAGE_SCREENING_FLAG,
  SET_MODAL_AGENT,
  SET_NEXT_QUESTIONNAIRE_STEP,
  SET_POST_SUBMIT_ANSWERS,
  SET_QUESTIONNAIRE_TOTAL_STEPS,
  SET_WHAT_YOU_SHOULD_KNOW_MODAL
} from "../../constants/reducer";

const reducer = (state, action) => {
  const type = action?.type ?? SET;

  switch (type) {
    case SET:
      return { ...state, ...action?.payload };
    case MERGE:
      return merge({}, state, action?.payload ?? {});
    case RESET_CONTACT_FORM_TYPE:
      return { ...state, contactFormType: null, isDrawerOpen: false };
    case SET_CONTACT_FORM_TYPE:
      return {
        ...state,
        contactFormType: action.payload,
        isDrawerOpen: true,
        isModalOpen: false
      };
    case SET_WHAT_YOU_SHOULD_KNOW_MODAL: {
      const { contactFormType, isModalOpen } = action.payload;
      return {
        ...state,
        contactFormType,
        isDrawerOpen: false,
        isModalOpen
      };
    }
    case RESET_MODAL_AGENT:
      return { ...state, modalAgent: null };
    case SET_MODAL_AGENT:
      return { ...state, modalAgent: action.payload };
    case RESET_MESSAGE_SCREENING_FLAG:
      return { ...state, messageScreeningFlag: null };
    case SET_MESSAGE_SCREENING_FLAG:
      return { ...state, messageScreeningFlag: action.payload };
    case SET_QUESTIONNAIRE_TOTAL_STEPS:
      return { ...state, questionnaireTotalSteps: action.payload };
    case RESET_QUESTIONNAIRE_STEP:
      return { ...state, questionnaireStepNumber: 0 };
    case SET_NEXT_QUESTIONNAIRE_STEP:
      return {
        ...state,
        questionnaireStepNumber: (state.questionnaireStepNumber ?? 0) + 1
      };
    case RESET_POST_SUBMIT_ANSWERS:
      return { ...state, postSubmitAnswers: null };
    case SET_POST_SUBMIT_ANSWERS:
      return merge({}, state, { postSubmitAnswers: action?.payload ?? {} });
    default:
      throw new Error();
  }
};

export default reducer;
